'use client';

import { createContext, useContext } from 'react';
import type { Account } from '@frameio/graphql-client/generated';

type AccountId = Account['id'] | undefined;

export const IsolatedActiveAccountIdContext =
  createContext<AccountId>(undefined);

export const useActiveAccountId = () =>
  useContext(IsolatedActiveAccountIdContext);

type IsolatedActiveAccountContextProviderProps = {
  children: React.ReactNode;
  accountId?: AccountId;
};

export const IsolatedActiveAccountIdContextProvider = ({
  accountId,
  children,
}: IsolatedActiveAccountContextProviderProps) => {
  return (
    <IsolatedActiveAccountIdContext.Provider value={accountId}>
      {children}
    </IsolatedActiveAccountIdContext.Provider>
  );
};
